import queryString from "query-string";

import { DEFAULT_BUYER_SPLIT, SALE_BUYER_SPLIT } from "constants/actionTypes";

import { serializeBuyerSplit } from "lib/serializers/buyerSplits";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { URLCreatorProps } from "./types";

const urlCreatorSale = ({
  changesSince,
  id,
  action,
  livestockSaleId,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/buyer-splits/", id, action),
    query: {
      changesSince,
      livestock_sale_id: livestockSaleId,
    },
  });

const urlCreatorDefault = ({
  changesSince,
  id,
  action,
}: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/buyer-splits/", id, action),
    query: { changesSince, is_default: true },
  });

export const DefaultBuyerSplitAction = offlineActionCreator(
  DEFAULT_BUYER_SPLIT,
  serializeBuyerSplit,
  urlCreatorDefault,
  false,
);

export const SaleBuyerSplitAction = offlineActionCreator(
  SALE_BUYER_SPLIT,
  serializeBuyerSplit,
  urlCreatorSale,
  true,
);
